import { SchedulesReportMethod } from "@common/types/reports/schedules-report";
import { DEFAULT_SCHEDULES_REPORT_METHOD } from "./useSchedulesReportParams";

/** The Method filter's choices; Milestone joins them once its flag is on. */
export function resolveSchedulesReportMethodOptions(options: {
    isMilestoneEnabled: boolean;
}): SchedulesReportMethod[] {
    return Object.values(SchedulesReportMethod).filter(
        (method) =>
            method !== SchedulesReportMethod.milestone ||
            options.isMilestoneEnabled,
    );
}

/** A method from the link or a saved view; Milestone falls back to the default while its flag is off. */
export function resolveSchedulesReportMethod(options: {
    method: SchedulesReportMethod | null | undefined;
    isMilestoneEnabled: boolean;
}): SchedulesReportMethod {
    const method = options.method ?? DEFAULT_SCHEDULES_REPORT_METHOD;
    return method === SchedulesReportMethod.milestone &&
        !options.isMilestoneEnabled
        ? DEFAULT_SCHEDULES_REPORT_METHOD
        : method;
}
